import ActivityCard from "components/ActivityPanel/ActivityCard";
import React from "react";
import ShowCardContent from "./ShowActivityCardContent";

interface Props {
  activity: server.dto.ShowActivity
}

const ShowActivityRowCard = (props: Props) => {
  const { activity } = props;

  return <ActivityCard
    activity={activity}
  >
    <ShowCardContent activity={activity} />
  </ActivityCard>;
};

export default ShowActivityRowCard;